import React, { useState, useRef, useEffect } from "react";
import { Typography } from "antd";
import PropTypes from "prop-types";
import styles from "./ExperienceBooking.module.css";

const { Text } = Typography
const DropdownSelector = ({ label, options, value, onChange, placeholder = "Select an option", activeTab, error }) => {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  const handleOptionSelect = (option) => {
    onChange(option);
    setOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className={styles.guestsWrapper} ref={containerRef}>
      <div className={`${styles.inputContainer} ${open ? styles.activeBorder : ""} ${error ? styles.errorBorder : ""}`}>
        <span className={styles.inputLabel}>{label}</span>
        <button
          type="button"
          className={styles.inputLink}
          onClick={() => {
            if (activeTab !== 2 && activeTab !== 3) {
              setOpen(!open)
            }
          }}
        >
          {value || placeholder}
        </button>
      </div>
      {error && <Text style={{ color: "red" }}>{`${label} is required.`}</Text>}
      {open && (
        <div className={styles.dropdownPanel}>
          <div className={styles.pillContainer}>
            {options.map((option) => (
              <button
                key={option}
                type="button"
                className={`${styles.pill} ${value === option ? styles.selected : ""}`}
                onClick={(e) => {
                  e.stopPropagation();
                  handleOptionSelect(option)
                }}
              >
                {option}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

DropdownSelector.propTypes = {
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  error: PropTypes.bool,
  activeTab: PropTypes.number
};

export default React.memo(DropdownSelector);
